import { ErrorSeverity } from "./ErrorSeverity";
import { Exception } from "./Exception";

export class ConflictException extends Exception {
  constructor({
    message,
    response = new Response(null, {
      status: 409,
    }),
    stack,
  }: {
    message: string;
    response?: Response;
    stack?: string;
  }) {
    super({
      errorSeverity: ErrorSeverity.ERROR,
      useErrorBoundary: false,
      name: "ConflictException",
      message,
      response,
      stack,
    });
  }
}
